import { render } from "./RequestsReceived.vue?vue&type=template&id=be9e6474&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=be9e6474&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9e6474"]])

export default __exports__